import { Box, Typography } from "@mui/material";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import MapLoadScreenMobile from "./mapLoadScreenMobile.jsx";
const NearbyStoresMobile = ({ product, open, zipcode }) => {
  const [stores, setStores] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [error, setError] = useState(null);
  const [address, setAddress] = useState(null);
  const [addressCity, setAddressCity] = useState(null);

  useEffect(() => {
    if(zipcode){
      setAddressCity(zipcode);
    }else {
      const getGeolocation = () => {
        if ("geolocation" in navigator) {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const { latitude, longitude } = position.coords;
              setLocation({ latitude, longitude });
              setError(null); // Clear any previous errors
  
              // Make the reverse geocoding request using Axios
              axios
                .get(`https://maps.googleapis.com/maps/api/geocode/json`, {
                  params: {
                    latlng: `${latitude},${longitude}`,
                    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
                  },
                })
                .then((response) => {
                  const data = response.data;
                  console.log("data web", data.results[0].address_components);
  
                  if (data.results && data.results.length > 0) {
                    const components = data.results[0].address_components;
  
                    // Look for the main postal code and set addressCity to it
                    let postalCode = null;
                    let city = null;
  
                    // Find postal code and city
                    components.forEach((component) => {
                      if (
                        component.types.includes("postal_code") &&
                        !postalCode
                      ) {
                        postalCode = component.long_name; // Prioritize main postal code
                      }
                      if (component.types.includes("locality")) {
                        city = component.long_name;
                      }
                    });
  
                    // If city is not found, fall back to postal code
                    setAddressCity(postalCode || city || "No city found.");
                    setAddress(postalCode || "No postal code found.");
                  } else {
                    setAddress("No address found.");
                  }
                })
                .catch((err) => {
                  setError("Error fetching address: " + err.message);
                });
            },
            (error) => {
              setError("Geolocation error: " + error.message);
            },
          );
        } else {
          console.error("Geolocation not supported.");
          setError("Geolocation is not supported by this browser.");
      
        }
      };
      getGeolocation();
    }
  }, [zipcode]);

  const calculateDistance = useCallback(
    (lat1, lon1) => {
      if (!location.latitude || !location.longitude) {
        return null;
      }
      const deltaLat = Math.abs(location.latitude - lat1);
      const deltaLon = Math.abs(location.longitude - lon1);

      const R = 69.1;
      const latDistance = deltaLat * R;
      const lonDistance = deltaLon * R * Math.cos(lat1 * (Math.PI / 180));
      const distance = latDistance + lonDistance;

      return distance.toFixed(2);
    },
    [location],
  );

  const fetchCoordinates = async (address) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json`,
        {
          params: {
            address: address,
            key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
          },
        },
      );
      if (response.data.status === "OK") {
        const location = response.data.results[0].geometry.location;
        return { lat: location.lat, lng: location.lng };
      } else {
        console.error("Geocoding error:", response.data.status);
        return null;
      }
    } catch (error) {
      console.error("Error fetching coordinates:", error);
      return null;
    }
  };

  const handleStoreClick = (store) => {
    setSelectedStore(store);
    console.log("selectedStore,", selectedStore);
  };

  useEffect(() => {
    if (
      open &&
      addressCity &&
      product
    ) {
      setLoading(true); // Set loading state when drawer is opened
      const fetchStores = async () => {
        try {
          const response = await axios.post(
            "/get_nearby_availability",
            {
              product,
              addressCity,
            },
            {
              headers: {
                "Content-Type": "application/json",
              },
            },
          );

          if (response.status === 404) {
            setStores([]);
          }

          console.log("mobile response data", response.data);

          const formattedStores = await Promise.all(
            response.data.map(async (place, index) => {
              const coordinates = await fetchCoordinates(place.address);
              return {
                id: index,
                name: place.name,
                address: place.address,
                ...(coordinates && {
                  lat: coordinates.lat,
                  lng: coordinates.lng,
                }),
                distanceAway: calculateDistance(
                  coordinates.lat,
                  coordinates.lng,
                ),
              };
            }),
          );

          const sortedStores = formattedStores.sort(
            (a, b) => a.distanceAway - b.distanceAway,
          );
          setStores(sortedStores);

          if (formattedStores.length > 0) {
            setSelectedStore(formattedStores[0]); // Set the first store as selected
          }
        } catch (error) {
          console.error("Error fetching stores:", error);
        } finally {
          setLoading(false); // Reset loading state
        }
      };

      fetchStores();
    } else {
      // Optionally clear out the stores if the drawer closes (depends on your use case)
      setStores([]);
      setSelectedStore(null);
    }
  }, [open, product, addressCity]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        paddingTop: "40px",
      }}
    >
      {/* Map Section */}
      <Box
        sx={{
          flex: 1,
          width: "100%",
          background: "white",
          borderRadius: "8px 8px 0 0",
          position: "relative",
          display: "flex", // Make the container a flexbox
    justifyContent: "center", // Center horizontally
    alignItems: "center", // Center vertically
        }}
      >
        {loading ? (
          <MapLoadScreenMobile/>
        ) : stores.length === 0 ? (
          <Typography
            variant="h6"
            align="center"
            sx={{ padding: 2, color: "#EF4F26", backgroundColor: "white" }}
          >
            No stores found
          </Typography>
        ) : (
          selectedStore && (
            <LoadScript
              googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
            >
              <GoogleMap
                mapContainerStyle={{ height: "40vh", width: "100%" }}
                center={{ lat: selectedStore.lat, lng: selectedStore.lng }}
                zoom={18}
              >
                <Marker
                  position={{ lat: selectedStore.lat, lng: selectedStore.lng }}
                />
              </GoogleMap>
            </LoadScript>
          )
        )}
      </Box>

      {/* Store List Section */}
      <Box
        sx={{
          height: "150px", // Fixed height for the store list section (can be adjusted)
          width: "100%",
          overflowX: "auto",
          padding: "10px",
          background: "#fff",
          borderRadius: "0 0 8px 8px",
          boxShadow: "0px -4px 10px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "row",
          gap: "10px",
        }}
      >
        {stores.map((store, index) => (
          <Box
            key={index}
            sx={{
              minWidth: "200px", // Adjust as per your design
              background: "#f5f5f5",
              padding: "10px",
              borderRadius: "8px",
              //border: selectedStore.id === store.id ? "2px solid #DF552E" : "2px solid #f5f5f5",
              cursor: "pointer",
              "&:hover": {
                border: "2px solid #DF552E",
              },
            }}
            onClick={() => handleStoreClick(store)}
          >
            <Typography variant="body1">
              <strong>{store.name}</strong>
            </Typography>
            <Typography variant="body2">{store.address}</Typography>
            {location.latitude && location.longitude && (
              <Typography variant="body2">
                {store.distanceAway + " Miles away"}
              </Typography>
            )}
            
          </Box>
        ))}
      </Box>
    </div>
  );
};

export default NearbyStoresMobile;